import { render, staticRenderFns } from "./pagethree.vue?vue&type=template&id=33f45e74&scoped=true"
import script from "./pagethree.vue?vue&type=script&lang=js"
export * from "./pagethree.vue?vue&type=script&lang=js"
import style0 from "./pagethree.vue?vue&type=style&index=0&id=33f45e74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f45e74",
  null
  
)

export default component.exports